<div (click)="isOpen = !isOpen"
     (mouseenter)="isOpen = true"
     (mouseleave)="isOpen = false"
     cdkOverlayOrigin
     #trigger="cdkOverlayOrigin">
  <ng-content select="[tooltip-trigger]"></ng-content>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  (overlayOutsideClick)="isOpen = false">
  <ng-content select="[tooltip-content]"></ng-content>
</ng-template>
